import * as React from 'react';

import {Button} from 'shells/button/button';
import {colors} from 'shells/colors/colors';
import {EmptyStateSmall} from 'shells/empty-states/empty-state-small';
import {TickCircleOutlineIcon} from 'shells/icon/svg/tick-circle-outline-icon';
import {ListView} from 'shells/list-view/list-view';
import {Body} from 'shells/typography/body';
import {SectionLabel} from 'shells/typography/section-label';

import {appHistory} from '../../../history';

import {ActivityItem} from './activity-item';
import {useGetActivities} from './graphql/hooks/use-get-activities';

import styles from './activities-section.module.css';

type Props = {
    entityId: string;
};

export function ActivitiesSection(props: Props) {
    const {activities, isLoading, refetch} = useGetActivities(props.entityId, 0, 100);

    const refetchActivities = () => {
        refetch();
    };

    React.useEffect(() => {
        // All events that should trigger a refetch of the activities
        const events = [
            Peep.events.reloadActivities,
            Lead.events.reloadActivities,
            'activityLogged',
            'activityCreated',
            'activityDeleted',
        ];

        events.forEach((event) => {
            $(window).on(event, refetchActivities);
        });

        // Cleanup function to remove all event listeners
        return () => {
            events.forEach((event) => {
                $(window).off(event, refetchActivities);
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={styles['activities-section']}>
            <div>
                <SectionLabel noBottomMargin={true}>Activities</SectionLabel>
                <ListView
                    collection={activities}
                    isOverflowAuto={true}
                    loadingState={{
                        numItems: 3,
                        itemHeight: 30,
                        listPadding: 0,
                        spacing: 8,
                    }}
                    renderRow={(activity) => <ActivityItem activity={activity} />}
                    isLoading={isLoading}
                    emptyStateComponent={
                        <div className='flex align-start px-8 py-16'>
                            <EmptyStateSmall
                                title='No upcoming activities'
                                titleSize='small'
                                subtitle='Schedule a meeting or phone call to remind yourself and your colleagues. Once the activity occurs, log it to see it in the timeline.'
                                subtitleSize='small'
                                // @ts-expect-error
                                icon={<TickCircleOutlineIcon size={47} fill={colors.offWhiteDk} />}
                                isFlexibleHeight={true}
                                iconSpacing={8}
                            />
                        </div>
                    }
                />
            </div>
            <Button
                size='big'
                isFullWidth={true}
                textAlign='left'
                onClick={() => {
                    appHistory.replace({
                        ...appHistory.location,
                        hash: `/create/activities/${props.entityId}`,
                        state: {modal: true},
                    });
                }}
            >
                <Body size='small' isBold={true}>
                    + Schedule an activity
                </Body>
            </Button>
        </div>
    );
}
